import { Flex, VFlex } from '@/components/base';
import { useSearchDetailContext } from '@/features/GlobalSearch/context/SearchDetailContext';
import { GLOBAL_SEARCH_VIEW } from '@/features/GlobalSearch/types/searchConst';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { CUSTOMER_DOMAIN } from '@/types/customerConst';
import {
  FEEDBACK_COLUMNS,
  SCORE_COLUMNS,
  SOURCE_COLUMNS,
} from '@/types/filterKeyConst';

import RelatedAccountsContainer from '../ResultContents/AccountTab/RelatedAccountsContainer';
import AgentDistributionContainer from '../ResultContents/AgentTab/AgentDistributionContainer';
import FeedbackAttrTopListContainer from '../ResultContents/FeedbackAttrTab/FeedbackAttrTopListContainer';
import KeySentimentDistributionContainer from '../ResultContents/FeedbackTab/KeySentimetDistribution/KeySentimentDistributionContainer';
import SearchFeedbackList from '../ResultContents/FeedbackTab/SearchFeedbackList';
import SearchFeedbackTrend from '../ResultContents/FeedbackTab/SearchFeedbackTrend';
import SearchSummary from '../ResultContents/FeedbackTab/SearchSummary/SearchSummary';
import ScoreDistChartContainer from '../ResultContents/ScoreTab/ScoreDistChartContainer';
import { ContentBox } from '../ResultContents/SearchContentStyles';
import SearchCustomerSegment from '../ResultContents/SearchCustomerSegment';
import TagTopListContainer from '../ResultContents/TagTab/TagTopListContainer';
import TopicTrend from '../ResultContents/TopicTab/TopicTrend';

type Props = {
  selectedTab: GLOBAL_SEARCH_VIEW;
};

const SearchTabRender = (props: Props) => {
  const { selectedTab } = props;
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const { searchResult } = useSearchDetailContext();
  if (!currWorkspace) return null;
  switch (selectedTab) {
    case GLOBAL_SEARCH_VIEW.FEEDBACK:
      return (
        <VFlex g={24}>
          <Flex g={24}>
            <ContentBox g={24} f={1} padding="24px">
              <SearchFeedbackTrend alias={searchResult.alias} />
            </ContentBox>
            <ContentBox
              style={{ width: 260, aspectRatio: 1, padding: 24 }}
              j="space-between"
            >
              <KeySentimentDistributionContainer alias={searchResult.alias} />
            </ContentBox>
          </Flex>
          <ContentBox padding="24px">
            <SearchSummary
              searchResult={searchResult}
              language={currWorkspace.language}
            />
          </ContentBox>
          <ContentBox padding="24px 0px 0px 24px">
            <SearchFeedbackList alias={searchResult.alias} />
          </ContentBox>
        </VFlex>
      );
    case GLOBAL_SEARCH_VIEW.TOPIC:
      return (
        <ContentBox>
          <TopicTrend />
        </ContentBox>
      );
    case GLOBAL_SEARCH_VIEW.ACCOUNT:
      return (
        <VFlex g={20}>
          <RelatedAccountsContainer />
          <SearchCustomerSegment domain={CUSTOMER_DOMAIN.ACCOUNT} />
        </VFlex>
      );
    case GLOBAL_SEARCH_VIEW.CONTACT:
      return (
        <VFlex>
          <SearchCustomerSegment domain={CUSTOMER_DOMAIN.CONTACT} />
        </VFlex>
      );
    case GLOBAL_SEARCH_VIEW.AGENT:
      return <AgentDistributionContainer />;
    case GLOBAL_SEARCH_VIEW.TAG:
      return <TagTopListContainer />;
    case GLOBAL_SEARCH_VIEW.REMARKS:
      return (
        <FeedbackAttrTopListContainer
          field={FEEDBACK_COLUMNS.REMARKS}
          title="Related remarks"
        />
      );
    case GLOBAL_SEARCH_VIEW.DATA_ORIGIN:
      return (
        <FeedbackAttrTopListContainer
          field={SOURCE_COLUMNS.DATA_ORIGIN}
          title="Related data origin"
        />
      );
    case GLOBAL_SEARCH_VIEW.CSAT:
      return (
        <ScoreDistChartContainer
          field={SCORE_COLUMNS.CSAT_SCORE}
          title="CSAT score distribution"
        />
      );
    case GLOBAL_SEARCH_VIEW.RATING_SCORE:
      return (
        <ScoreDistChartContainer
          field={SCORE_COLUMNS.RATING_SCORE}
          title="Rating score distribution"
        />
      );
    case GLOBAL_SEARCH_VIEW.NPS:
      return (
        <ScoreDistChartContainer
          field={SCORE_COLUMNS.NPS_SCORE}
          title="NPS score distribution"
        />
      );
    case GLOBAL_SEARCH_VIEW.CES:
      return (
        <ScoreDistChartContainer
          field={SCORE_COLUMNS.CES_SCORE}
          title="CES score distribution"
        />
      );
    default:
      return null;
  }
};

export default SearchTabRender;
